
import cookies from 'js-cookie'
import storage from 'good-storage'

const fee = {
	namespaced: true,
	state: {
		
	},
	mutations: {

	},
	actions: {

	}

}

export default fee